<template>
  <div>
    <v-dialog
      v-model="mutableShow"
      width="40%"
    >
      <v-card
        color="primary"
        dark
      >
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        />
      </v-card>
    </v-dialog>
    <div
      v-if="freezeScreen && mutableShow"
      class="overlay"
    />
  </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        freezeScreen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mutableShow: null,
        };
    },
    watch: {
        show: {
            handler() {
                this.mutableShow = this.show;
            },
            immediate: true,
        },
    },
};
</script>
<style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }
</style>
